let loader;

const GLTFCache = new Map();

export default function loadGLTF(url) {
    if (GLTFCache.has(url)) {
        return Promise.resolve({ ...GLTFCache.get(url) });
    }

    return import('three/examples/jsm/loaders/GLTFLoader')
        .catch(() => {
            console.warn('could not load GLTFLoader, is three installed?');
        })
        .then(({ GLTFLoader }) => {
            if (!loader) loader = new GLTFLoader();

            return new Promise((resolve) => {
                loader.load(url, (result) => {
                    GLTFCache.set(url, result);

                    resolve(result);
                });
            });
        });
}
